
// import axios from 'axios';
// const REACT_APP_API_BASE_URL="http://127.0.0.1:2601/api/v1/"
// const axiosInstance = axios.create({
//   baseURL: REACT_APP_API_BASE_URL
 
// });
// axiosInstance.interceptors.request.use(
//   config => {
//     const token = localStorage.getItem('authToken'); // Or wherever you store your token
//     if (token) {
//       config.headers['Authorization'] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   error => {
//     return Promise.reject(error);
//   }
// );



// export default axiosInstance;



// import axios from 'axios';

// const axiosInstance = axios.create({
//   baseURL: process.env.REACT_APP_API_BASE_URL,
 
// });
// axiosInstance.interceptors.request.use(
//   config => {
//     const token = localStorage.getItem('authToken'); // Or wherever you store your token
//     if (token) {
//       config.headers['Authorization'] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   error => {
//     return Promise.reject(error);
//   }
// );



// export default axiosInstance;

import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// ==========================
// REQUEST INTERCEPTOR
// ==========================
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ==========================
// RESPONSE INTERCEPTOR
// ==========================
axiosInstance.interceptors.response.use(
  (response) => response,

  (error) => {
    const status = error?.response?.status;
    const requestURL = error?.config?.url; // the endpoint that caused error

    // Skip logout logic for login endpoint
    if (requestURL?.includes("/login")) {
      return Promise.reject(error);
    }

    // Handle Forbidden / Unauthorized
    if (status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("email");
      localStorage.removeItem("isLoggedIn");
      sessionStorage.removeItem("u_t");

      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
